import React from 'react';
import { Target, Lightbulb, AlertTriangle } from 'lucide-react';

interface LessonBoxProps {
    title: string;
    children: React.ReactNode;
    icon: React.ElementType;
    colorClass: string;
    iconColor: string;
}

const LessonBox: React.FC<LessonBoxProps> = ({ title, children, icon: Icon, colorClass, iconColor }) => (
    <div className={`my-8 p-6 rounded-xl border-l-4 ${colorClass} transition-all duration-200 hover:shadow-md`}>
        <div className="flex items-center gap-3 mb-3">
            <div className={`p-2 rounded-lg bg-white shadow-sm ring-1 ring-black/5 ${iconColor}`}>
                <Icon size={20} strokeWidth={2.5} />
            </div>
            <h4 className="m-0 text-[1.1rem] font-medium tracking-tight">{title}</h4>
        </div>
        <div className="text-[1rem] leading-relaxed opacity-90">
            {children}
        </div>
    </div>
);

export const KeyFacts: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <LessonBox
        title="Key Facts & Engineering Context"
        icon={Target}
        colorClass="bg-[#e8f0fe] border-[#1a73e8] text-[#174ea6]"
        iconColor="text-[#1a73e8]"
    >
        {children}
    </LessonBox>
);

export const ProTip: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <LessonBox
        title="Pro-Tip"
        icon={Lightbulb}
        colorClass="bg-[#e6f4ea] border-[#1e8e3e] text-[#0d652d]"
        iconColor="text-[#1e8e3e]"
    >
        {children}
    </LessonBox>
);

export const Warning: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <LessonBox
        title="Avoid This"
        icon={AlertTriangle}
        colorClass="bg-[#fce8e6] border-[#d93025] text-[#a50e0e]"
        iconColor="text-[#d93025]"
    >
        {children}
    </LessonBox>
);
